import React from 'react';
import { numberPosition } from '../../utils';

export const PositionNumberTag = ({ position }) => (
    <span className={`position-number-tag ${numberPosition(position)}`}>
        {position}
    </span>
)
